import { useMemo, useState, useTransition } from "react";

export const ITEMS_PER_LOAD = 5;

// Mounting 70+ discipline rows with their reference lookups at once stalls the page.
export const useIncrementalRows = (rows, step = ITEMS_PER_LOAD) => {
  const [visibleCount, setVisibleCount] = useState(step);
  const [isPending, startTransition] = useTransition();

  const loadMore = () => startTransition(() => setVisibleCount(count => count + step));

  // Stays in effect once chosen, so rows added later are not hidden again.
  const showAll = () => startTransition(() => setVisibleCount(Number.POSITIVE_INFINITY));

  // A fresh slice on every parent render would re-render all visible rows.
  const visibleRows = useMemo(() => rows.slice(0, visibleCount), [rows, visibleCount]);

  return {
    visibleRows,
    remaining: Math.max(0, rows.length - visibleCount),
    isPending,
    loadMore,
    showAll,
  };
};
